import { render, staticRenderFns } from "./NextBtn.vue?vue&type=template&id=f137f1fa&scoped=true&"
import script from "./NextBtn.vue?vue&type=script&lang=ts&"
export * from "./NextBtn.vue?vue&type=script&lang=ts&"
import style0 from "./NextBtn.vue?vue&type=style&index=0&id=f137f1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f137f1fa",
  null
  
)

export default component.exports